import { useContext } from "react";
import { SpaceContext, type SpaceContextValue } from "@/contexts/space-context";

/** 현재 공간·전환 함수. SpaceProvider(Layout 안) 밖에서 부르면 에러. */
export function useSpace(): SpaceContextValue {
  const ctx = useContext(SpaceContext);
  if (!ctx) throw new Error("useSpace 는 SpaceProvider 안에서만 쓸 수 있습니다");
  return ctx;
}
